import { Routing } from "@common/_constants/";
import { TelemetryService, UserService } from "@common/_services";
import * as React from "react";
import { Route } from "react-router-dom";

export default class PrivateRoute extends Route {
    componentDidMount() {
        const user = UserService.getUserFromStorage();
        if (!user) {
            //save redirect for later user.
            UserService.saveRelodeRedirect(window.location.href);
        }

        if (!this.props.location) return;

        let url = this.props.location.pathname;
        if (!!this.props.location.search) {
            url += this.props.location.search;
        }

        TelemetryService.trackRoute(this.props.location.pathname, url, null);
    }

    render() {
        const user = UserService.getUserFromStorage();

        if (
            user &&
            (user.applicationName === "pro")
        ) {
            return <Route {...this.props} />;
        }

        window.location.href = Routing.Client.Account.SIGN_OUT;
        return null;
    }

    componentDidUpdate(prevProps) {
        if (!this.props.location) return;

        // if we are not changing then skip
        if (
            prevProps &&
            prevProps.location &&
            prevProps.location.pathname === this.props.location.pathname &&
            prevProps.location.search === this.props.location.search
        ) {
            return;
        }

        let url = this.props.location.pathname;
        if (!!this.props.location.search) {
            url += this.props.location.search;
        }

        TelemetryService.trackRoute(this.props.location.pathname, url, null);
    }
}
